import { render, staticRenderFns } from "./EmailLogs.vue?vue&type=template&id=351e4c42&"
import script from "./EmailLogs.vue?vue&type=script&lang=js&"
export * from "./EmailLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports